export const articleBySlugQuery = `
  *[_type == "article" && slug.current == $slug][0]{
    _id,
    title,
    "slug": slug.current,
    heroImage,
    body,
    "excerpt": body[0...2]
  }
`

export const siteSettingsQuery = `
  *[_type == "siteSettings"][0]{
    title,
    logo,
    quote,
    quoteAuthor,
    navigation,
    backgroundImages,
    footer,
    newsletter
  }
`

export const eventGalleryQuery = `
  *[_type == "eventGallery"][0]{
    images[]{
      ...,
      "url": asset->url
    }
  }
`

export const pageBySlugQuery = `
  *[_type == "page" && slug.current == $slug][0]{
    _id,
    title,
    subtitle,
    "slug": slug.current,
    heroImage,
    body,
    pdf,
    "pdfUrl": pdf.asset->url,
    pdfLabel,
    contact,
    gallery[]{
      ...,
      "url": asset->url
    }
  }
`
